import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { UiButtonLink } from 'teacher-ui-client/components/ui-button/link'
import { t } from 'ember-intl'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

interface Args {
  href?: string
}

export const EntriesButtonVideo: TOC<Args> = <template>
  {{#if @href}}
    <UiButtonLink href={{@href}} target="_blank" rel="noopener noreferrer" @appearance={{ButtonAppearance.regular}}>
      <PhosphorIcon @icon="phosphor-play-circle-fill" />
      {{t "components.tiles.entries.buttonVideo"}}
    </UiButtonLink>
  {{/if}}
</template>

export default EntriesButtonVideo
